// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MBqb","newExpiryDate":"styles_newExpiryDate__39WSQ","footer":"styles_footer__AekDG"};